export const DEFAULT_EXERCISE_POINTS = 15
export const DEFAULT_VIDEO_OVERLAY_EXERCISE_POINTS = 30
export const DEFAULT_CONVERSATION_POINTS = 150
